import * as React from "react";

import { Box, Grid, Radio } from "@mui/material";
import "../../../../assets/styles/graph-question.css";

export default function Graph({ question, onAnswer = () => {} }) {
	const list = question.questionList;
	const [answer, setAnswer] = React.useState({});

	const scores = list.map((l) => {
		return l.value;
	});
	const [graph, setGraph] = React.useState(question.sampleValues);

	const totalRows = Math.max(...scores) + 1;
	const totalColumns = list.length + 1;
	const colWidth = `${100 / totalColumns}%`;

	React.useEffect(() => {
		// reset proceed button
		setAnswer({});
	}, [question]);

	const handleSetGraph = (e, c, graphText) => {
		let newGraph = [...graph];
		newGraph[c - 1] = e.target.value;
		setGraph(newGraph);

		const ans = { ...answer };
		ans[graphText] = e.target.value;
		setAnswer(ans);

		const canProceed =
			Object.keys(ans).length === question.totalQuestions;

		onAnswer({
			canProceed,
			answer: ans,
		});
	};

	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ pt: 2, px: { xs: 3, sm: 5 }, pb: 5 }}
			>
				<Box>
					<Grid
						item
						key={Math.random()}
						xs={12}
						sm={12}
						sx={{ mb: 4 }}
					>
						<Grid
							container
							justifyContent="center"
							alignItems="center"
							sx={{ textAlign: "center", flexDirection: "column" }}
							className="q-table-container"
						>
							{list.map((lbl, z) => (
								<Grid
									item
									key={`col-lbl-${z}-${Math.random()}`}
									// className="q-table-header"
									// width={`${100 / list.length}%`}
                                    width="100%"
								>
                                    <Grid container>
                                        <Grid item className="q-table-header" width="60%">{lbl.label}</Grid>
                                        <Grid item width="40%">{lbl.value}</Grid>
                                    </Grid>
								</Grid>
							))}
							{/* {list.map((ans, a) => (
								<Grid
									item
									className="q-table-body"
									key={`col-ans-${a}-${Math.random()}`}
									width={`${100 / list.length}%`}
								>
									{ans.value}
								</Grid>
							))} */}
						</Grid>
					</Grid>
				</Box>
				<Grid
					container
					justifyContent="center"
					sx={{ textAlign: "center" }}
				>
					{Array(totalRows)
						.fill("")
						.map((x, i) => (
							<Grid item key={Math.random()} xs={12} sm={12}>
								<Grid
									container
									justifyContent="center"
									className="graph-container"
									alignItems="center"
									sx={{ position: "relative" }}
								>
									{Array(totalColumns)
										.fill("")
										.map((col, c) => {
											if (c === 0) {
												return (
													<Grid
														key={`col-lbl-${c}`}
														item
														width={colWidth}
													>
														{totalRows - i}
													</Grid>
												);
											} else {
												return (
													<Grid
														item
														key={`col-val-${c}`}
														width={colWidth}
														className={
															typeof graph[
																c - 1
															] !== "undefined" &&
															graph[c - 1] >=
																totalRows - i
																? "graph-selected"
																: "graph-unselected"
														}
													>
														<Radio
															sx={{
																opacity:
																	typeof graph[
																		c - 1
																	] !==
																	"undefined"
																		? 0
																		: 1,
															}}
															disabled={
																list[c - 1]
																	.isSample ===
																true
															}
															checked={
																typeof graph[
																	c - 1
																] !==
																	"undefined" &&
																graph[c - 1] ===
																	totalRows -
																		i
															}
															value={
																totalRows - i
															}
															onClick={(e) => {
																handleSetGraph(
																	e,
																	c,
																	list[c - 1]
																		.text
																);
															}}
														/>
													</Grid>
												);
											}
										})}
								</Grid>
							</Grid>
						))}
					<Grid
						item
						key={Math.random()}
						xs={12}
						sm={12}
						className="graph-bottom-label"
					>
						<Grid
							container
							justifyContent="center"
							alignItems="center"
							sx={{ textAlign: "center" }}
						>
							{Array(totalColumns)
								.fill("")
								.map((lbl, z) => (
									<Grid
										item
										key={`col-lbl-${z}-${Math.random()}`}
										width={colWidth}
										// className={
										// 	z > 0
										// 		? z % 2
										// 			? "graph-col-dark"
										// 			: "graph-col-light"
										// 		: ""
										// }
                                        sx={{
                                            transform: "rotate(-30deg)",
                                            marginTop: '14px'
                                        }}
									>
										{typeof list[z - 1] !== "undefined" &&
											list[z - 1].label}
									</Grid>
								))}
						</Grid>
					</Grid>
				</Grid>
			</Box>
		</React.Fragment>
	);
}
